export default "__VITE_ASSET__CFj3JzRv__"